import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { saveLocale } from '@/i18n'

export function useLocaleDir() {
  const { locale } = useI18n()

  function applyHtmlAttrs(lang: string) {
    const l = lang as 'en' | 'ar'
    document.documentElement.lang = l
    document.documentElement.dir = l === 'ar' ? 'rtl' : 'ltr'
    saveLocale(l)
  }

  watch(
    locale,
    (v) => {
      applyHtmlAttrs(v)
    },
    { immediate: true },
  )

  return { applyHtmlAttrs }
}
